/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Withdrawal_ActionInputs */

const en_withdrawal_action = /** @type {(inputs: Withdrawal_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdraw from contract here`)
};

const pl_withdrawal_action = /** @type {(inputs: Withdrawal_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odstąp od umowy tutaj`)
};

/**
* | output |
* | --- |
* | "Withdraw from contract here" |
*
* @param {Withdrawal_ActionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_action = /** @type {((inputs?: Withdrawal_ActionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_ActionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_action(inputs)
	return en_withdrawal_action(inputs)
});